export const container = `
  py-3 items-center grid
  grid-cols-1 md:grid-cols-[2fr_1fr] 
  [&>a]:justify-end
`;
